import {compareBudgets} from './iis-savings-core.js';
const form = document.getElementById('savings-form');
if (form) {
  const currency = document.getElementById('savings-currency');
  const rate = document.getElementById('savings-rate');
  const status = document.getElementById('savings-status');
  const results = document.getElementById('savings-results');
  const money = new Intl.NumberFormat('it-IT', {style:'currency', currency:'EUR', maximumFractionDigits:2});
  const format = cents => money.format(cents / 100);
  const set = (id, text) => { document.getElementById(id).textContent = text; };
  let announce;
  function message(text) { clearTimeout(announce); announce = setTimeout(() => { status.textContent = text; }, 250); }
  function clearResults(text) {
    ['saving-it-month','saving-ch-month','saving-difference'].forEach(id => set(id, '—'));
    ['saving-it-year','saving-ch-year'].forEach(id => set(id, 'Risultato annuale da calcolare'));
    ['saving-it-cost','saving-ch-cost'].forEach(id => set(id, 'Spese mensili da calcolare'));
    set('saving-difference-year', 'Differenza annuale da calcolare');
    set('saving-winner', 'Scopri quale budget ti lascia più margine.');
    document.getElementById('savings-chart').hidden = true;
    results.classList.remove('has-result');
    message(text);
  }
  function update() {
    const francs = currency.value === 'CHF';
    document.getElementById('savings-rate-row').hidden = !francs;
    rate.required = francs;
    rate.disabled = !francs;
    form.querySelectorAll('[data-country="ch"]').forEach(input => input.parentElement.querySelector('.savings-unit').textContent = francs ? 'CHF' : '€');
    const inputs = [...form.querySelectorAll('[data-country]')];
    if (inputs.some(input => input.validity.badInput || (input.value !== '' && !input.validity.valid))) {
      clearResults('Usa importi non negativi, con al massimo due decimali.'); return;
    }
    const itIncome = document.getElementById('it-income');
    const chIncome = document.getElementById('ch-income');
    if (itIncome.value === '' || chIncome.value === '') {
      clearResults('Inserisci i due stipendi netti e le spese per vedere il confronto.'); return;
    }
    if (francs && (!rate.validity.valid || rate.value === '' || !Number.isFinite(rate.valueAsNumber))) {
      clearResults('Inserisci un cambio positivo: quanti euro vale 1 CHF?'); return;
    }
    const budget = country => ({income: document.getElementById(country + '-income').valueAsNumber, expenses: [...form.querySelectorAll(`[data-country="${country}"]:not([data-kind="income"])`)].map(input => input.value === '' ? 0 : input.valueAsNumber)});
    const value = compareBudgets(budget('it'), budget('ch'), francs ? rate.valueAsNumber : 1);
    set('saving-it-month', format(value.italyMargin));
    set('saving-ch-month', format(value.swissMargin));
    set('saving-it-year', format(value.italyMargin * 12) + ' in 12 mesi');
    set('saving-ch-year', format(value.swissMargin * 12) + ' in 12 mesi');
    set('saving-it-cost', 'Spese mensili: ' + format(value.italyCosts));
    set('saving-ch-cost', 'Spese mensili: ' + format(value.swissCosts));
    const signed = cents => (cents > 0 ? '+' : '') + format(cents);
    set('saving-difference', signed(value.difference) + ' / mese');
    set('saving-difference-year', signed(value.difference * 12) + ' in 12 mesi');
    const winner = value.difference > 0 ? 'Il budget svizzero lascia più margine.' : value.difference < 0 ? 'Il budget italiano lascia più margine.' : 'I due budget lasciano lo stesso margine.';
    set('saving-winner', winner);
    const deficit = value.italyMargin < 0 || value.swissMargin < 0;
    message(winner + (deficit ? ' Attenzione: almeno un budget ha spese superiori al netto.' : ' Stima basata sui valori inseriti.'));
    const max = Math.max(value.italyMargin, value.swissMargin);
    document.getElementById('savings-chart').hidden = deficit || max === 0;
    document.getElementById('saving-it-bar').style.width = max > 0 ? (Math.max(0,value.italyMargin) / max * 100) + '%' : '0%';
    document.getElementById('saving-ch-bar').style.width = max > 0 ? (Math.max(0,value.swissMargin) / max * 100) + '%' : '0%';
    results.classList.add('has-result');
  }
  form.addEventListener('input', update);
  form.addEventListener('change', update);
  form.addEventListener('submit', event => { event.preventDefault(); update(); if (!form.reportValidity()) return; results.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'}); });
  form.addEventListener('reset', () => setTimeout(update, 0));
  update();
}
